import { useToast } from '@/hooks/use-toast';
import html2canvas from 'html2canvas';

export function useChartExport() {
  const { toast } = useToast();

  const exportToPNG = async (elementId: string, filename: string, prefix?: string) => {
    try {
      const element = document.getElementById(elementId);
      if (!element) {
        throw new Error('Element niet gevonden');
      }

      // Capture the element as canvas
      const canvas = await html2canvas(element, {
        scale: 2, // Higher quality
        backgroundColor: '#ffffff',
        logging: false,
        useCORS: true,
      });

      // Convert to blob and download
      canvas.toBlob((blob) => {
        if (!blob) return;
        
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        const finalFilename = prefix ? `${prefix}_${filename}` : filename;
        link.download = `${finalFilename}.png`;
        link.href = url;
        link.click();
        URL.revokeObjectURL(url);

        toast({
          title: 'Download succesvol',
          description: `${finalFilename}.png is gedownload`,
        });
      });
    } catch (error) {
      console.error('Export error:', error);
      toast({
        title: 'Download mislukt',
        description: 'Er is een fout opgetreden bij het exporteren',
        variant: 'destructive',
      });
    }
  };

  return { exportToPNG };
}
